'use strict';
import angular from 'angular';
import linksAndMainCtaHtmlUrl from './views/linksAndMainCta.html';

var app = angular.module('app.linksAndMainCta.component', []);
app.component('linksAndMainCta', {
    bindings: {
        showActions: '=',
        sets: '=',
        model: "=",
    },
    templateUrl: linksAndMainCtaHtmlUrl,
    controller: function (ProductService) {
        this.links = [];
        this.maxSelections = 3;
        this.selectedCount = 0;
        this.enableEditView = false;
        this.toggleSelection = function (link) {
            if (!this.enableEditView) {
                return;
            }
            if (link.selected) {
                this.selectedCount++;
            } else {
                this.selectedCount--;
            }
            if (this.selectedCount > this.maxSelections) {
                link.selected = false;
                this.selectedCount--;
            }
            this.sets = this.links;
        };
        this.isDisabled = function (link) {
            return !this.enableEditView || (this.selectedCount === this.maxSelections && !link.selected);
        };
        this.initComponent = function () {
            this.enableEditView = true;
            if (this.sets) {
                if (typeof this.sets === 'string') {
                    this.links = JSON.parse(this.sets);
                }
                this.selectedCount = this.links.filter(link => link.selected === true).length;
                this.enableEditView = this.showActions || false;
            }
        };
        this.initComponent();
    }
});